<div
    class="toastWrapper"
    [ngClass]="{
        rightToast: position === 'right',
    }"
>
    @for (toast of toasts; track toast; let index = $index) {
        <div
            @toastEnterLeave
            class="toast"
            [ngClass]="toast.toastData.severity"
            [class.simple]="toast.toastData.type === 'simple' && toast.toastData.clickHandler"
            [class.actionable]="toast.toastData.type === 'actionable'"
            (click)="toast.toastData.type === 'simple' && handleClick(index, toast.toastData.clickHandler)"
        >
            <i
                class="fal fa-fw toastIcon"
                [ngClass]="{
                    'fa-circle-check': toast.toastData.severity === 'success',
                    'fa-circle-info': toast.toastData.severity === 'info',
                    'fa-circle-exclamation': toast.toastData.severity === 'error',
                    'fa-triangle-exclamation': toast.toastData.severity === 'warning',
                }"
            ></i>

            <div class="toastContainer">
                <div class="toastContent">
                    <span>{{ toast.toastData.body | translate: toast.toastData.args }}</span>
                    @if (toast?.toastData?.listArguments && toast?.toastData?.listArguments?.length) {
                        <div>
                            @switch (toast.toastData.listType) {
                                @case ('none') {
                                    <ul class="noBullets">
                                        @for (argument of toast.toastData.listArguments; track argument) {
                                            <li>{{ argument }}</li>
                                        }
                                    </ul>
                                }
                                @case ('unordered') {
                                    <ul>
                                        @for (argument of toast.toastData.listArguments; track argument) {
                                            <li>{{ argument }}</li>
                                        }
                                    </ul>
                                }
                                @case ('ordered') {
                                    <ol>
                                        @for (argument of toast.toastData.listArguments; track argument) {
                                            <li>{{ argument }}</li>
                                        }
                                    </ol>
                                }
                            }
                        </div>
                    }
                </div>

                @if (toast.toastData.type === 'actionable') {
                    <button type="button" class="button transparent link" (click)="handleClick(index, toast.toastData.clickHandler)">
                        <i class="fa fa-sm fa-arrow-up-right-from-square"></i>
                        {{ toast.toastData.actionButtonText ?? 'generalKeywords.ok' | translate }}
                    </button>
                }
            </div>
            <i class="fat fa-xmark close" (click)="removeToast(index)" title="{{ 'toast.dismiss' | translate }}"></i>
        </div>
    }
</div>
